import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiData } from '@wix/da-bi/pkg/events';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import BooleanInput from '@wix/da-ds/pkg/formControls/dsPresets/BooleanInput';
import { PremiumTrash } from '@wix/da-ds/pkg/Icons/Confirmations';
import { deviationTypeToTranslationKey, getDeviationResourceType, getDeviationType } from '../../../../DeviationViews/_helpers';
import ConfirmationModal from '../../../../Popup/ConfirmationModal';
import s from './DeleteConfirmationModal.scss';
const DeleteConfirmationModal = (_param)=>{
    var { deviation, onConfirm } = _param, rest = _object_without_properties(_param, [
        "deviation",
        "onConfirm"
    ]);
    var _deviation_extended_adoptable, _deviation_extended, _deviation_extended_adoptable1, _deviation_extended1, _deviation_author;
    const { t } = useTranslation();
    const logBiEvent = useBiLogger();
    const isAdopted = deviation.isAdoptable && ((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : (_deviation_extended_adoptable = _deviation_extended.adoptable) === null || _deviation_extended_adoptable === void 0 ? void 0 : _deviation_extended_adoptable.owner) && ((_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : (_deviation_extended_adoptable1 = _deviation_extended1.adoptable) === null || _deviation_extended_adoptable1 === void 0 ? void 0 : _deviation_extended_adoptable1.owner.username) !== ((_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.username);
    const [isConfirmable, setIsConfirmable] = useState(!isAdopted);
    const toggleIsConfirmable = useCallback(()=>{
        setIsConfirmable(!isConfirmable);
    }, [
        setIsConfirmable,
        isConfirmable
    ]);
    const type = getDeviationType(deviation);
    const typeName = t(deviationTypeToTranslationKey(type));
    const handleConfirmation = useCallback(()=>{
        logBiEvent(BiData({
            evid: 376,
            itemid: deviation.deviationId,
            typeid: getDeviationResourceType(deviation)
        }));
        onConfirm && onConfirm();
    }, [
        logBiEvent,
        onConfirm,
        deviation
    ]);
    return /*#__PURE__*/ React.createElement(ConfirmationModal, _object_spread({
        title: t('actionbar.delete.confirm', {
            type: typeName
        }),
        text: isAdopted ? /*#__PURE__*/ React.createElement("div", null, t('actionbar.delete.cantGoBack.adopted'), /*#__PURE__*/ React.createElement(BooleanInput, {
            type: "checkbox",
            size: "small",
            id: "delete-confirm",
            value: isConfirmable,
            className: s['checkbox'],
            label: t('actionbar.delete.cantGoBack.adopterConsent'),
            labelClassName: s['checkbox-label'],
            onChange: toggleIsConfirmable
        })) : t('actionbar.delete.cantGoBack'),
        confirmBtnLabel: t('actionbar.delete'),
        cancelBtnLabel: t('popup.cancel'),
        icon: /*#__PURE__*/ React.createElement(PremiumTrash, null),
        confirmBtnType: "danger",
        confirmBtnDisabled: !isConfirmable,
        onConfirm: handleConfirmation
    }, rest));
};
DeleteConfirmationModal.displayName = 'DeleteConfirmationModal';
export default DeleteConfirmationModal;
